import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const DeleteModal = ({ isOpen, onConfirm, onCancel, data }) => {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>{data === 'remove' ? `Remove assigned number` : `Delete ${data}?`}</ModalHeader>
      <ModalBody>
        Do you really want to {data === 'remove' ? `unassign the number?` : `delete the ${data}?`}
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          No
        </Button>
        <Button color="primary" onClick={onConfirm}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
